enum StatusPage {
  Fake = 'fake',
  Default = '',
}

export default StatusPage
